import * as Service from 'types/service';
import { createSelector } from 'reselect';
import partiesSelector from 'selectors/service/partiesSelector';

/**
 * Check if all provided parties lack a specified seating area
 */
const partiesAllLackSeatingArea = (parties: Service.Party[]) => {
  const allSeatingAreaIds = parties
    .map(({ purchase }) => purchase?.seatingAreaName)
    .filter((val) => val !== undefined);
  return allSeatingAreaIds.length === 0;
};

export const shouldHideAllSeatingAreasSelector = createSelector(
  partiesSelector,
  partiesAllLackSeatingArea
);
